interface ModalOptions {
  title?: string
  description?: string
  confirm?: () => void
  cancel?: () => void
  component?: string // component name or component reference
  componentProps?: Record<string, any> & { businessName?: string }
}
const base_modal: ModalOptions = {
  title: '',
  description: '',
  confirm: undefined,
  cancel: undefined,
  component: undefined,
  componentProps: {},
}

const modalOptions = ref<ModalOptions>({ ...base_modal })
export default function useGlobalModal(onClose?: () => void) {
  // Store the modal options in state (excluding functions)

  const modalOpen = useState('modal-open', () => false)

  // Open the modal with options (without functions)
  const openModal = (options: ModalOptions) => {
    Object.assign(modalOptions.value, {
      title: options.title,
      description: options.description,
      component: options.component,
      componentProps: options.componentProps,
      confirm: options.confirm,
      cancel: options.cancel,
    })
    modalOpen.value = true
  }

  // Close the modal
  const closeModal = () => {
    modalOpen.value = false
    setTimeout(() => {
      modalOptions.value = { ...base_modal }
      if (onClose) onClose()
    }, 500) // Reset options after animation
  }

  return {
    modalOptions,
    modalOpen,
    openModal,
    closeModal,
  }
}
